import { SubdimensionsByName } from '@features/reports/subdomains/visitation';
import { FormSchema } from './form-schema';
import { sanitizeFormKey } from '@utils/form-keys';
import { defaultRecommendations } from '@features/executive-report/domain/default-recommendations';
import { defaultObservations } from '@features/executive-report/domain/default-observations';

export const defaultValues = (
  campaignName: string,
  subdimensionsByName: SubdimensionsByName
): FormSchema => ({
  campaignName,
  teamMembers: [],
  salesObjectives: [
    {
      value:
        'Drive incremental sales and traffic through a multi-channel media approach.',
    },
    {
      value:
        'Identify best media audiences to reach our ideal customer target.',
    },
  ],
  salesDimensionRecommendations: {
    who: '',
    what: '',
    where: '',
  },
  footTrafficObjectives: [
    {
      value:
        'Drive incremental sales and traffic through a multi-channel media approach.',
    },
    {
      value:
        'Identify best media audiences to reach our ideal customer target.',
    },
  ],
  footTrafficDimensionRecommendations: {
    who: '',
    what: '',
    where: '',
  },
  observations: defaultObservations,
  recommendations: defaultRecommendations,
  subdimensionImagesByNameAndValue: Object.entries(subdimensionsByName).reduce(
    (acc, [dimensionSlug, subdimensions]) => {
      acc[dimensionSlug] = subdimensions.reduce(
        (acc, subdimension) => {
          if (!acc) return acc;

          acc[sanitizeFormKey(subdimension.value)] = null;
          return acc;
        },
        {} as FormSchema['subdimensionImagesByNameAndValue'][string]
      );
      return acc;
    },
    {} as FormSchema['subdimensionImagesByNameAndValue']
  ),
  includedSlides: {
    intro: {
      title: true,
      meetYourTeam: true,
      agenda: true,
      navigatingComplexity: true,
      incrementalityMatters: true,
    },
    sales: {
      cover: true,
      campaignOverview: true,
      campaignOverview2: true,
      who: true,
      what: true,
      where: true,
      optimizationSummary: true,
    },
    footTraffic: {
      cover: true,
      overview: true,
      who: true,
      what: true,
      where: true,
    },
    takeaways: {
      recommendations: true,
      discoverWhatsNext: true,
    },
    campaignInsights: {
      cover: true,
      audienceProfile: true,
      demographicProfile: true,
      topLocations: true,
      moreStats: true,
      visitorProfile: true,
    },
  },
  youtubeImpressions: null,
});
